// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0
import { getApiUrl, isKeycloakEnabled } from '../../config.js';

import { upload } from '../../utils/CoreService';

async function fetchFileSummary(formData, topics = '') {
  if (topics) {
    formData.append('topics', topics);
  }
  const url = `${getApiUrl()}/summary/file`;
  const response = await upload(url, formData);

  return response;
}

export default fetchFileSummary;
